var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCupraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h124v124H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.768 49.283a10478.485 10478.485 0 0 0 19.343-30.339C98.758 25.458 80.431 32.014 62 38.305c-18.405-6.291-36.758-12.856-55.111-19.36C13.33 29.08 19.782 39.203 26.24 49.316l9.22-3.543-5.575-9.381 17.884 8.784-10.901 4.183c-2.245.862-4.892 1.886-5.899 4.61-1.007 2.722.47 5.155 1.784 7.213l5.976 9.321c7.05 11.058 14.119 22.107 21.204 33.147V93.408a1306.48 1306.48 0 0 1-7.905-25.61 784.102 784.102 0 0 1-2.15-7.307c-.445-1.468-.154-2.347 1.263-3.047L61.974 52.1l10.876 5.352c1.417.7 1.69 1.58 1.263 3.048-.71 2.435-1.428 4.871-2.151 7.307a1687.093 1687.093 0 0 1-7.905 25.61v10.243C71.131 92.62 78.2 81.57 85.262 70.513l5.975-9.322c1.306-2.091 2.766-4.558 1.784-7.213-.981-2.655-3.653-3.756-5.898-4.61l-10.901-4.183 17.9-8.792-5.574 9.347 9.22 3.543z",
    fill: "#1B1B1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupraIcon);
export default __webpack_public_path__ + "static/media/cupra-icon.4abfb14affe6c1026bdb672341bbfc06.svg";
export { ForwardRef as ReactComponent };